import type { useTranslations } from 'next-intl'
import { z } from 'zod'

export function getForgotFormSchema({
  t,
}: {
  t: ReturnType<typeof useTranslations>
}) {
  return z.object({
    email: z.string().min(1, {
      message: t('form.inputs.email.label'),
    }),
  })
}

export type ForgotFormValues = z.infer<ReturnType<typeof getForgotFormSchema>>
